import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { PaymentStore } from "./store/payment.store";
import { CrispService } from "./services/crisp.service";
import { PRODUCT_BRAND } from "./product";

@Component({
  selector: "app-root",
  imports: [RouterOutlet],
  templateUrl: "./app.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly paymentStore = inject(PaymentStore);
  private readonly crispService = inject(CrispService);

  constructor() {
    // Token quota and billing are Talk BI concepts; HouseClaw would only surface their warnings out of context.
    if (inject(PRODUCT_BRAND).product === "talkbi") {
      this.paymentStore.initialize();
    }
    this.crispService.initialize();
  }
}
